import React from 'react';
import PropTypes from 'prop-types';

const PrimaryPlus = ({ fill, theme, ...props }) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="8" cy="8.5" r="8" fill="#6930CA" />
    <circle cx="7.99978" cy="8.49978" r="7.11111" fill="#6930CA" />
    <path
      d="M8.36211 8.13779L8.36205 6.34405L8.36049 6.31195C8.33851 6.12028 8.18427 5.982 8 5.982C7.8138 5.982 7.65852 6.12313 7.63982 6.30724L7.63818 6.3354L7.63803 8.13766L5.84417 8.13783L5.81177 8.13943C5.63354 8.16003 5.50111 8.29442 5.48399 8.46307L5.48234 8.49123L5.48242 8.50985L5.48372 8.53228C5.50433 8.71051 5.63871 8.84294 5.80736 8.86007L5.83552 8.86171L7.63791 8.86174L7.63797 10.6557L7.63917 10.6839C7.65853 10.8766 7.81381 11.0178 8.00002 11.0178L8.02815 11.0166L8.05815 11.0124C8.2354 10.9808 8.36207 10.8321 8.36207 10.6557L8.36199 8.86187L10.1559 8.86194L10.184 8.86074C10.3768 8.84138 10.5179 8.6861 10.5179 8.4999C10.5179 8.29994 10.3558 8.13785 10.1559 8.13785L8.36211 8.13779Z"
      fill="white"
      stroke="white"
      stroke-width="0.5"
    />
  </svg>
);

PrimaryPlus.propTypes = {
  fill: PropTypes.string,
  theme: PropTypes.object,
};

export default PrimaryPlus;
